import type { PersonDirectoryAction } from "../types/personDirectoryAccess.js";
import type { SessionContext } from "../types/user.js";
import { personDirectoryActionsPermittedByRole } from "./personDirectoryActionsPermittedByRole.js";

/**
 * Whether any role the session context combines lets it take this action in
 * the person directory; none without a session context.
 */
export const mayActInPersonDirectory = (
  sessionContext: SessionContext | null,
  action: PersonDirectoryAction,
): boolean =>
  sessionContext?.roles.some((role) =>
    personDirectoryActionsPermittedByRole(role).includes(action),
  ) ?? false;
